// components/PageTitle.tsx
import { useEffect } from 'react';
import { usePageTitle } from '@contexts/pagetitle';

type Props = {
  title: string;
};

export function PageTitle({ title }: Props) {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);

  return null;
}
